const _menuBtn = $('#js-hamburger');
const _menuCloseBtn = $('#js-closeNavigation');
const _header = $('#js-header');
const _navigation = $('#js-navigation');

_menuBtn.on('click', function () {
	if ($('body').css('overflow') === 'hidden') {
			$('body').css({
					'overflow': 'auto',
					'height': 'auto'
			});
	} else {
			$('body').css({
					'overflow': 'hidden',
					'height': '100%'
			});
	}
	_menuBtn.toggleClass('-show');
	_navigation.toggleClass('-show');
});

_menuCloseBtn.on('click', function () {
	$('body').css({
			'overflow': 'auto',
			'height': 'auto'
	});
	_menuBtn.removeClass('-show');
	_navigation.removeClass('show');
});

$('a[href^="#"]').on('click', function () {
	$('body').css({
			'overflow': 'auto',
			'height': 'auto'
	});
	_menuBtn.removeClass('-show');
	_navigation.removeClass('-show');
});


// ---------------------------------------------------------
// Scroll
// ---------------------------------------------------------
let startPos = 0;
let windowPos;
const $header = $('#header');

// スクロールイベントを設定
$(window).on('scroll', function () {
	// スクロール量の取得
	windowPos = $(this).scrollTop();

	if (windowPos > 160) {
		_header.addClass('-fixed');
	} else {
		_header.removeClass('-fixed');
	}

	if (windowPos > 200) {
		$('html').addClass('-scrolled');
	} else {
		$('html').removeClass('-scrolled');
	}

	if (windowPos < startPos) {
		_header.addClass('-active');
		_header.addClass('-show');
	} else {
		_header.removeClass('-show');
	}
	// 現在の位置を更新する
	startPos = windowPos;
});
// 中途半端なところでロードされても良いようにスクロールイベントを発生させる
$(window).trigger('scroll');

// ---------------------------------------------------------
// submenu
// ---------------------------------------------------------

$(document).on("click", ".js-mega-menu-open", function () {
	$(this).parents('.l-navigation__list').addClass('active');
	$(this).next().addClass('active');
	$(".l-header__link ").css("display", "none");
});
$(document).on("click", ".js-mega-menu-close", function () {
	$('.l-navigationMega__child').removeClass('active');
	$('.l-navigation__list').removeClass('active');
	$(".l-header__link ").css("display", "block");
});

